import { Link } from 'react-router-dom';
import styles from './SiteFooter.module.css';
import { Logo } from '../ui';
import {
  LANGUAGES,
  PRIVACY_POLICY_URL,
  TELEGRAM_BOT_URL,
  TERMS_URL,
} from '../../config.js';

/*
 * Site footer.
 *
 * The language pills are a static statement of coverage, exactly as in the
 * design prototype — the marketing pages are English-only for now. They become
 * a real switcher when the marketing copy is translated.
 */
export function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className={styles.footer}>
      <div className={styles.wrap}>
        <div className={styles.grid}>
          <div className={styles.brand}>
            <Link to="/" aria-label="Don Quack home">
              <Logo size={28} />
            </Link>
            <p>AI sports forecasts you can trust — across 9 sports and 4 languages.</p>
          </div>

          <div>
            <h4>Product</h4>
            <Link to="/app">Web app</Link>
            <a href="#accuracy">Track record</a>
            <a href="#pricing">Pricing</a>
            <a href={TELEGRAM_BOT_URL}>Telegram bot</a>
          </div>

          <div>
            <h4>Company</h4>
            <a href="#how">How it works</a>
            <a href="#faq">FAQ</a>
            <a href={TELEGRAM_BOT_URL}>Contact</a>
          </div>

          <div>
            <h4>Legal</h4>
            {/* Link, not <a>: these are in-app routes now, and an anchor would
                force a full page reload of the SPA. */}
            <Link to={TERMS_URL}>Terms of Service</Link>
            <Link to={PRIVACY_POLICY_URL}>Privacy policy</Link>
            <a href="#faq">Responsible play</a>
          </div>
        </div>

        <div className={styles.bottom}>
          <span>
            © {year} Don Quack · 18+ · Forecasts are for entertainment, not financial advice.
          </span>
          <div className={styles.langs}>
            {LANGUAGES.map((l) => (
              <span key={l.code} className={l.code === 'en' ? styles.on : ''}>
                {l.short}
              </span>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
